module.exports = " <product-category-cmp id=\"{{_renderCategory.id}}-product-category\" class=\"product-category level-0 clearfix\" [ngClass]=\"{'compact': _renderCategory.renderMode === 'compact',\r\n        'expanded': _renderCategory.renderMode === 'expanded',\r\n        'custom-renderer': _renderCategory.customRenderer !== null }\" *ngIf=\"_renderCategory !== null\" [catalogState]=\"catalogState\" [category]=\"_renderCategory\" [level]=\"0\"> </product-category-cmp>";


//////////////////
// WEBPACK FOOTER
// ./app/catalog/shared/components/product-categories/product-categories.cmp.html
// module id = 849
// module chunks = 1